import { createContext, useReducer, useEffect, useState } from 'react';
import { Spinner, Modal, Button } from 'react-bootstrap';
import jwtDecode from 'jwt-decode'

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, user: action.payload, loading: false };
    case 'LOGOUT':
      return { ...state, user: null, loading: false };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    loading: true,
  });

  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      console.log("Validating token expiration date...");
      if (!decoded || !decoded.exp) {
        console.log("TOKEN EXPIRED.....") 
        return true;
      }
      const expirationDate = new Date(decoded.exp * 1000);
      const currentDate = new Date();
      return currentDate > expirationDate;
    } catch (error) {
      console.log('err', error)
      return true;
    }
  };

  const triggerSessionExpired = () => {
    // check if url is /setup
    if (window.location.pathname === '/setup') {
      console.log('User is on /setup; session expiration modal suppressed.');
      return; // Prevent the modal from firing
    }
    setIsSessionExpired(true);
    dispatch({ type: 'LOGOUT' });
  };

  const handleSessionExpired = () => {
    setIsSessionExpired(false);
  };

  // may be causing requests to stop / repeat when ran
  // on home screen, will 
  useEffect(() => {
    const checkAuthStatus = () => {
      console.log("Checking auth status...")
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && user.token) {
        if (isTokenExpired(user.token)) {
          setIsSessionExpired(true);
          dispatch({ type: 'LOGOUT' });
        } else {
          dispatch({ type: 'LOGIN', payload: user });
        }
      } else {
        dispatch({ type: 'LOGOUT' });
      }

      dispatch({ type: 'SET_LOADING', payload: false }); // this 
    };

    checkAuthStatus();

    const intervalId = setInterval(checkAuthStatus,  1000 * 10830); 

    return () => clearInterval(intervalId);
  }, [dispatch]);



  if (state.loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '90vh' }}>
        <Spinner animation="grow" size="lg" className="loadSpinner" />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ ...state, dispatch, triggerSessionExpired  }}>
      {children}
      {isSessionExpired && (
        <Modal show={true} onHide={handleSessionExpired} centered>
          <Modal.Header>
            <Modal.Title>Session Expired</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Your session has expired. Please log in again to continue.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleSessionExpired}>
              Login Again
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </AuthContext.Provider>
  );
};
